import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { webAuthnAuthenticatorQueryKeys, WebAuthnAuthenticators } from '#api';

export const webAuthnAuthenticatorsQueryOptions = queryOptions({
  queryKey: webAuthnAuthenticatorQueryKeys.list(),
  queryFn: ({ signal }) => WebAuthnAuthenticators.getAuthenticators({ signal }),
});

export function useSuspenseWebAuthnAuthenticatorsQuery() {
  return useSuspenseQuery(webAuthnAuthenticatorsQueryOptions);
}

export function useEditWebAuthnAuthenticator() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: WebAuthnAuthenticators.editAuthenticator,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: webAuthnAuthenticatorQueryKeys.lists() });
    },
  });
}
